/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Externalid1Inputs */

const en_entity_externalid1 = /** @type {(inputs: Entity_Externalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External ID`)
};

const de_entity_externalid1 = /** @type {(inputs: Entity_Externalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe ID`)
};

/**
* | output |
* | --- |
* | "External ID" |
*
* @param {Entity_Externalid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_externalid1 = /** @type {((inputs?: Entity_Externalid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Externalid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_externalid1(inputs)
	return de_entity_externalid1(inputs)
});
export { entity_externalid1 as "entity_externalId" }